import type { VoidFunctionComponent } from 'react';
import styles from './NoResults.module.less';

/**
 * Renders a message indicating that no results matched the search.
 */
const CommandPaletteNoResults: VoidFunctionComponent = () => (
  <div className={styles.noResults}>
    No results matched your search
  </div>
);

export default CommandPaletteNoResults;
